import React from "react";

import { resourceTypes } from "../../../utils/CommonFunctions";

import styles from "../../../styles/sass/searchresult.module.scss";

const ResourceItem = (props) => {
  const { resource = {}, filter } = props;
  const mFilter = filter && JSON.parse(filter);
  const resource_type = mFilter?.type || "";
  const resType = resourceTypes[resource_type];
  const imageSrc = resType?.img;

  const amenities = resource?.amenities_id;
  const actual_price = resource?.actual_price?.net || 0;
  const dynamic_price = resource?.dynamic_price?.net || 0;
  const priceIncreased = dynamic_price - actual_price;
  // const priceIncreasedPercent = (priceIncreased * 100) / actual_price || 0;

  return (
    <div className={styles["resource"]}>
      <div className={styles["nw_bk_img_cb"]}>
        <img src={imageSrc} alt="resource-image" />
      </div>
      <div className={styles["nw_o_details"]}>
        <div className={styles["details"]}>
          <h3> {resource?.name}</h3>
          {resource_type?.includes?.("desk") && (
            <div className="d_i">
              <p>Seat No</p>
              <span>
                {resource?.items.map(
                  (item, i) =>
                    `${item?.seat_no}${
                      resource?.items?.length - 1 > i ? ", " : ""
                    }`
                )}
              </span>
            </div>
          )}

          <div className={styles["d_i"]}>
            <p>Amenties</p>
            <span>
              {" "}
              {amenities
                ?.filter((a) => a?.active)
                ?.map(
                  (a, i) =>
                    `${a?.title}${amenities?.length - 1 > i ? ", " : ""}`
                )}
            </span>
          </div>
          <p className="price">
            {`£ ${parseFloat(resource?.dynamic_price?.net).toFixed(2)}`}
            {resource_type?.includes?.("desk") ? (
              <span> per seat</span>
            ) : resource_type === "meeting_room" ? (
              <span> per hour</span>
            ) : (
              ""
            )}
          </p>
          <a
            className={styles["booknow-btn"]}
            onClick={() => props.onBookNow?.(resource?._id)}
          >
            BOOK NOW
          </a>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ResourceItem);
